module.exports = __webpack_public_path__ + "static/media/everyreel_woman.a1ee5f79.png";